module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "moduleIdentifier": "shopee",
      "title": _vm.$t('shopee.account.label')
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': !_vm.shopeeAccount.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false)
      }
    }
  }, [_vm._v("\n          Inativo\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': _vm.shopeeAccount.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(true)
      }
    }
  }, [_vm._v("\n          Ativo\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-3@md img-account"
  }, [(_vm.shopeeAccount.logo) ? _c('img', {
    attrs: {
      "src": _vm.shopeeAccount.logo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.shopeeAccount.logo) ? _c('i', {
    staticClass: "icon-image2 no-photo"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-col-9@md"
  }, [_c('panel', {
    attrs: {
      "title": "Dados da conta"
    }
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Nome:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.shopeeAccount.shopName)))]), _vm._v(" "), _c('div', {
    staticClass: "cnpj-group"
  }, [_c('form-group', {
    attrs: {
      "label": "CNPJ:",
      "columns": 12,
      "bold": true
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('NN.NNN.NNN/NNNN-NN'),
      expression: "'NN.NNN.NNN/NNNN-NN'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpj),
      expression: "cnpj"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "CNPJ da conta"
    },
    domProps: {
      "value": (_vm.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpj = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilizado para faturamento dos pedidos da conta no ERP. Vazio remove o CNPJ.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "disabled": _vm.savingCnpj
    },
    on: {
      "click": _vm.saveCnpj
    }
  }, [_vm._v("Salvar")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": "Autenticação"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn",
    attrs: {
      "data-label": "Renovar token"
    },
    on: {
      "click": _vm.refreshToken
    }
  }, [_c('i', {
    staticClass: "icon-sync icon-loop2"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Token de acesso:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.shopeeAccount.accessToken)))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Token de renovação:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.shopeeAccount.refreshToken)))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Data de expiração:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.shopeeAccount.expirationDate.replace('.000Z', ''), 'DD/MM/YYYY HH:mm')))])])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77dba11e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAccount/Shopee/Edit.vue
// module id = 3303
// module chunks = 0